















import Selector from '~/components/global/selector'
export default

	components: { Selector }

	props: 
		region: String
		regions: Array

